<template>
    <v-container>
      <v-form
        ref="invoiceForm"
        lazy-validation>
        <v-row justify="space-around">
            <v-col cols="6" md="5">
                <v-select
                v-model="invoiceNumber.documentTypeId"
                :items="documentTypesItems"
                :item-text="getDocumentTypeText"
                item-value="documentTypeId"
                v-bind:label="$t('documentType')"
                @change="changeDocumentType"
                v-bind:no-data-text="$t('noData')"
                required
                >
                </v-select>
                <v-text-field
                v-model.trim="invoiceNumber.startNumber"
                :rules="startNumberRule"
                v-bind:label="$t('startNumber')">
                </v-text-field>
                <v-text-field
                v-model.trim="invoiceNumber.prefix"
                v-bind:label="$t('prefix')">
                </v-text-field>
                <v-text-field
                v-model.trim="invoiceNumber.suffix"
                v-bind:label="$t('suffix')">
                </v-text-field>
                <v-select
                v-if="invoiceNumber.documentTypeId >= 5"
                v-model="invoiceNumber.itemCode"
                :items="itemsCodes"
                item-text="code"
                item-value="code"
                v-bind:label="$t('itemCode')"
                v-bind:no-data-text="$t('noData')"
                @change="changeDocumentType"
                >
                </v-select>
                <v-btn 
                class="mx-2"
                :dark="hasChanged"
                :disabled="!hasChanged"
                color="#2b5d66"
                @click="save">
                {{ $t('save') }}
                </v-btn>
                <v-btn 
                class="mx-2"
                :dark="hasChanged"
                :disabled="!hasChanged"
                color="#2b5d66"
                @click="cancel">
                {{ $t('cancel') }}
                </v-btn>
                <v-btn 
                class="mx-2"
                :dark="invoiceNumber.invoiceNumberId > 0"
                :disabled="invoiceNumber.invoiceNumberId <= 0"
                color="#2b5d66"
                @click="deleteSetting">
                {{ $t('delete') }}
                </v-btn>
            </v-col>
        </v-row>
      </v-form>
    </v-container>
</template>

<script>
    export default {
        name: "InvoiceNumber",
        components: {
        },
        data() {
            return {
                initialInvoiceNumber: {
                    invoiceNumberId: -1,
                    documentTypeId: 0,
                    prefix: "",
                    suffix: "",
                    startNumber: "",
                    itemCode: ""
                },
                invoiceNumber: {
                    invoiceNumberId: -1,
                    documentTypeId: 0,
                    prefix: "",
                    suffix: "",
                    startNumber: "",
                    itemCode: ""
                },
                documentTypesItems: [],
                itemsCodes: []
            }
        },
        created() {
            this.docTypes();
            this.getItemsCodes();
        },
        mounted() {
            this.invoiceNumberSettings();
        },
        computed: {
            selectedOrganization() {
                return this.$store.getters.organizationId;
            },
            loggedUser() {
                return this.$store.getters.loggedUser;
            },
            hasChanged () {
                return JSON.stringify(this.invoiceNumber) !== JSON.stringify(this.initialInvoiceNumber)
            },
            startNumberRule() {
                const rules = []
                if(this.invoiceNumber.startNumber.length > 0){
                    const rule = v => (!isNaN(parseFloat(v)) && /^\d+$/.test(v)) || 'Broj > 0'
                    rules.push(rule)
                }
                return rules
            },
        },
        methods: {
            docTypes() {
                this.axios.get('InvoiceUtilities/GetDocumentTypesForInvoiceNumber').then((response) => {  
                    this.documentTypesItems = response.data;  
                    this.invoiceNumber.DocumentTypeId = this.documentTypesItems[0].documentTypeId;
                })
                .catch(err => console.log(err)); 
            }, 
            invoiceNumberSettings() {
                this.axios.get('InvoiceNumber/InvoiceNumberSettings?organizationId=' + this.selectedOrganization + '&documentTypeId=' + this.invoiceNumber.documentTypeId + '&itemCode=' + this.invoiceNumber.itemCode).then((response) => {  
                    this.initialInvoiceNumber = response.data;  
                    if(this.initialInvoiceNumber.startNumber == 0)
                        this.initialInvoiceNumber.startNumber = ''
                    this.invoiceNumber = JSON.parse(JSON.stringify(this.initialInvoiceNumber))
                    console.log(response.data)
                })
                .catch(err => console.log(err)); 
            },
            changeDocumentType() {
                if(this.invoiceNumber.documentTypeId < 5)
                    this.invoiceNumberSettings()
                else if(this.invoiceNumber.documentTypeId >= 5 && this.invoiceNumber.itemCode != null && this.invoiceNumber.itemCode.length > 0)
                    this.invoiceNumberSettings()
                
            },
            save() {
                var formData = new FormData()
                if(this.invoiceNumber.startNumber.length == 0)
                    this.invoiceNumber.startNumber = 0
                formData.append('invoiceNumberJson', JSON.stringify(this.invoiceNumber))

                this.axios.post('InvoiceNumber/SaveInvoiceNumberSetting?organizationId=' + this.selectedOrganization, formData)
                .then(response => {
                    this.initialInvoiceNumber = response.data
                    if(this.initialInvoiceNumber.startNumber == 0)
                        this.initialInvoiceNumber.startNumber = ''
                    this.invoiceNumber = JSON.parse(JSON.stringify(this.initialInvoiceNumber))
                    this.$root.displayNotificationMsg(this.$t('saved'), 'success')
                })
                .catch(err => console.log(err)); 
            },
            cancel() {
                this.invoiceNumber = JSON.parse(JSON.stringify(this.initialInvoiceNumber))
            },   
            deleteSetting() {
                this.axios.delete('InvoiceNumber/DeleteInvoiceNumberSetting?id=' + this.invoiceNumber.invoiceNumberId)
                .then(response => {
                    this.initialInvoiceNumber = response.data
                    if(this.initialInvoiceNumber.startNumber == 0)
                        this.initialInvoiceNumber.startNumber = ''
                    this.invoiceNumber = JSON.parse(JSON.stringify(this.initialInvoiceNumber))
                    this.$root.displayNotificationMsg(this.$t('deleted'), 'success')
                })
                .catch(err => console.log(err)); 
            },
            getDocumentTypeText(item) {
                if(localStorage.getItem('language') === 'eng')
                    return item.documentTypeEng;
                else
                    return item.documentType;
            },   
            getItemsCodes() {
              this.itemsCodes = this.loggedUser.itemCode.filter(c =>  { return c.organizationId ==  this.selectedOrganization || c.organizationId == -1});
              if(this.itemsCodes.length > 1)
                  this.itemsCodes = this.itemsCodes.slice(1);
            },                 
        }
    }
</script>